/* RESPONSIBLE TEAM: team-standalone */

import { default as OriginalRoute } from 'embercom/routes/apps/app/automation/fin-ai-agent/custom-answers/unanswered-questions';

export default class Route extends OriginalRoute {
  templateName = 'apps/app/automation/fin-ai-agent/custom-answers/unanswered-questions';
  controllerName = 'apps/app/automation/fin-ai-agent/custom-answers/unanswered-questions';
}
